import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import styles from './Tabs.styles';

function Tabs({ children, ...props }) {
  const childrenWithProps = React.Children.map(children, child =>
    React.cloneElement(child, { ...props }),
  );
  return <View style={styles.container}>{childrenWithProps}</View>;
}

Tabs.propTypes = {
  children: PropTypes.node,
};

export default Tabs;
